import { render, staticRenderFns } from "./SideIcon.vue?vue&type=template&id=9b10577a&lang=pug&"
import script from "./SideIcon.vue?vue&type=script&lang=js&"
export * from "./SideIcon.vue?vue&type=script&lang=js&"
import style0 from "./SideIcon.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports